import styles from './spinner.module.scss';
import classNames from 'classnames';

export type Props = {
  className?: string;
  isSmall?: boolean;
  spinnerClassName?: string;
  top?: string;
  withMask?: boolean;
};

const Spinner = ({
  className = '',
  isSmall = false,
  spinnerClassName = '',
  top = '100%',
  withMask = false,
}: Props) => {
  const a11yProps = {
    tabIndex: 0,
    role: 'alert',
    'aria-busy': true,
    'aria-live': 'polite',
    'aria-label': polyglot.t('global.loading'),
  } as const;

  return (
    <div
      {...a11yProps}
      id='spinner'
      data-testid='spinner'
      className={classNames(withMask && styles.mask, styles[className])}
    >
      <div
        style={{ top }}
        className={classNames(
          styles.spinner,
          isSmall && styles['spinner--small'],
          styles[spinnerClassName],
        )}
      />
    </div>
  );
};

export default Spinner;
